export const finance = {
  id: 'finance',
  name: 'Finance & Banking',
  sectionOrder: ['summary', 'experience', 'education', 'skills', 'certifications'],
  defaultLayout: 'single-column',
  recommendedTemplates: ['harvard-classic', 'finance-pro'],
  components: {
    experience: 'experience-classic',
    skills: 'skills-simple-list',
    header: 'header-centered'
  }
};
export default finance;
